// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/products",
  Short: "/pyr/products/short",
  Detail: "/pyr/products",
  Create: "/pyr/products",
  Update: "/pyr/products",
  Delete: "/pyr/products",
};
